<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path opacity="0.25" d="M9 0C4.03746 0 0 4.03746 0 9C0 13.9625 4.03746 18 9 18C13.9625 18 18 13.9625 18 9C18 4.03746 13.9625 0 9 0Z" fill="currentColor"/>
    <path d="M8.00003 13.9974C8.38406 13.9656 9.14032 13.8074 9.52038 13.7441C10.3741 13.6018 10.9998 12.8632 10.9995 11.998H9.42772L10.9399 7.84084C11.0512 7.53428 11.0063 7.19257 10.8188 6.92555C10.6318 6.65851 10.2303 6.51403 9.99997 6.49938C9.61551 6.47491 8.87647 6.63459 8.4798 6.75127C7.64859 6.9957 6.9987 7.63262 7.00004 8.49885H8.57228L7.06011 12.656C6.9488 12.9625 6.99373 13.3042 7.18121 13.5712C7.36821 13.8383 7.67496 14.0243 8.00003 13.9974Z" fill="currentColor"/>
    <path d="M8.99998 4.99975C8.99998 5.55184 9.44768 5.9995 9.99997 5.9995C10.5523 5.9995 11 5.55187 11 4.99975C11 4.44759 10.5523 4 9.99997 4C9.44768 4 8.99998 4.44759 8.99998 4.99975Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    name: 'InfoIcon',
  };
</script>
